import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssociateAddressSmallComponent } from './associate-address-small/associate-address-small.component';
import { AssociateAddressMediumComponent } from './associate-address-medium/associate-address-medium.component';
import { AssociateAddressLargeComponent } from './associate-address-large/associate-address-large.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonMaterialComponentsModule } from '@quorum/common-material-components';
import { FlexLayoutModule } from '@angular/flex-layout';
// eslint-disable-next-line max-len
import { AssociateAddressSmallLoadingComponent } from './associate-address-small-loading/associate-address-small-loading.component';
import { CreateAssociateAddressComponent } from './create-associate-address/create-associate-address.component';
import { CommonPipesModule } from '@quorum/common-pipes';
import { TextMaskModule } from 'angular2-text-mask';
import { NgPipesModule } from 'ngx-pipes';
import { VehicleOwnerCreateDialogComponent } from './vehicle-owner-create-dialog/vehicle-owner-create-dialog.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonMaterialComponentsModule,
    FlexLayoutModule,
    CommonPipesModule,
    TextMaskModule,
    NgPipesModule,
  ],
  declarations: [
    AssociateAddressSmallComponent,
    AssociateAddressMediumComponent,
    AssociateAddressLargeComponent,
    AssociateAddressSmallLoadingComponent,
    CreateAssociateAddressComponent,
    VehicleOwnerCreateDialogComponent,
  ],
  exports: [
    AssociateAddressSmallComponent,
    AssociateAddressMediumComponent,
    AssociateAddressLargeComponent,
    AssociateAddressSmallLoadingComponent,
    CreateAssociateAddressComponent,
    VehicleOwnerCreateDialogComponent,
  ],
})
export class ShaAssociatesNgUiModule {}
